// src/tutoriel/navigation.js — OÙ LA BULLE PEUT S'ARRÊTER.
//
// Logique pure, sans React ni DOM, pour être testée telle quelle. Le contenu
// vient du serveur ; ici on ne décide que d'une chose : la bulle ne s'arrête
// que sur une étape DISPONIBLE. Le panneau montre les autres, grisées et avec
// leur raison — mais y faire atterrir la bulle, c'est proposer « Suivant » sur
// une étape que le serveur refusera (409).

/** Les étapes à plat, chacune sachant son chapitre. */
export const aplatir = (chapitres) =>
  (chapitres || []).flatMap(ch => ch.etapes.map(e => ({ ...e, chapitre: ch.titre })));

/**
 * L'index de la prochaine étape disponible dans un sens (+1 / -1), ou null
 * s'il n'y en a plus : null vers l'avant, c'est « Terminer ».
 */
export const dispoDepuis = (etapes, depuis, sens) => {
  for (let i = depuis + sens; i >= 0 && i < etapes.length; i += sens) {
    if (etapes[i].disponible) return i;
  }
  return null;
};

/**
 * Où ouvrir un parcours : la première étape disponible sans statut ; tout
 * fait, on revoit depuis la première disponible.
 */
export const premiereAFaire = (etapes) => {
  const i = etapes.findIndex(e => e.disponible && !e.statut);
  if (i >= 0) return i;
  const d = etapes.findIndex(e => e.disponible);
  return d >= 0 ? d : 0;
};
